import { BackSide, DoubleSide, FrontSide } from "three";

//------------------------------ CONSTANTS

// Const for targetting specific threejs properties

//Object3D
export const K_PROPS_OBJECT = [
  'position',
  'scale',
  'rotation',
  'castShadow',
  'receiveShadow',
  'visible'
];

// All popular Materials 
export const K_PROPS_MATERIAL = [
  'color',
  'emissive',
  'roughness',
  'metalness',
  'clipShadows',
  'depthTest',
  'depthWrite',
  'opacity',
  'side',
  'transparent',
  'visible',
  'wireframe'
];

// All popular lights
export const K_PROPS_LIGHT = [
  'color',
  'groundColor',
  'intensity',
  'decay',
  'distance',
  'power',
  'height',
  'width',
  'angle',
  'penumbra',
  'castShadow',
  'receiveShadow',
  'position'
];

// Fog
export const K_PROPS_FOG = ['color','near', 'far'];

// All popular cameras
export const K_PROPS_CAMERA = [
  'far',
  'near',
  'bottom',
  'left',
  'right',
  'top',
  'zoom','aspect',
  'focus',
  'fov',
  'filmGauge',
  'filmOffset',
  'position',
  'rotation',
  'castShadow',
  'frustumCulled',
  'quaternion',
  'receiveShadow',
  'visible'
];


//------------------------------ OPTIONS

// Material binding options
export const K_MATERIAL_OPTIONS = {
  opacity:    { min:0, max:1, step:0.1 },
  color:      { color: { type: 'float' }},
  emissive:   { color: { type: 'float' } },
  roughness:  { min:0, max:1, step:0.1 },
  metalness:  { min:0, max:1, step:0.1 },
  side:       { options:{ front:FrontSide, back:BackSide, double:DoubleSide } },
};

// Light binding options
export const K_LIGHT_OPTIONS = {
  intensity:  { min:0 },
};

// Light binding options
export const K_FOG_OPTIONS = {
  near:       { min:0 },
};

export const K_COLOR_OPTIONS = {
  color:      {type: 'float'}
}
